
// Mock fallback activities for SuggestedActivities
import type { Activity } from "./ActivityTypes";

export const mockActivities: Activity[] = [
  {
    id: '1',
    title: 'Review candidate profiles',
    description: 'Review 3 new software engineer applications and schedule initial interviews',
    priority: 'high',
    type: 'task',
    time: '9:00 AM',
    status: 'pending',
    source: 'ai_generated',
    related_entity: {
      type: 'job',
      id: 'job-123',
      name: 'Software Engineer'
    }
  },
  {
    id: '2',
    title: 'Team hiring sync',
    description: 'Discuss hiring pipeline and open positions with department heads',
    priority: 'high',
    type: 'meeting',
    time: '10:30 AM',
    status: 'pending',
    source: 'ai_generated'
  },
  {
    id: '3',
    title: 'Follow up with candidates',
    description: 'Send follow-up emails to candidates from yesterday\'s interviews',
    priority: 'medium',
    type: 'email',
    time: '2:00 PM',
    status: 'pending',
    source: 'ai_generated',
    related_entity: {
      type: 'candidate',
      id: 'cand-456',
      name: 'Recent Interviews'
    }
  },
  {
    id: '4',
    title: 'Update job descriptions',
    description: 'Revise and update job descriptions based on latest requirements',
    priority: 'low',
    type: 'task',
    status: 'pending',
    source: 'ai_generated'
  },
  {
    id: '5',
    title: 'Check in with new hire',
    description: 'Schedule a quick catch-up with the new frontend developer',
    priority: 'medium',
    type: 'followup',
    status: 'pending',
    source: 'ai_generated',
    related_entity: {
      type: 'candidate',
      id: 'cand-789',
      name: 'Frontend Developer'
    }
  }
];
